function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEvents = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M70.79,8.42l-0,-4.62l-4.62,0l-0,4.62l-32.34,0l0,-4.62l-4.62,0l0,4.62l-13.86,0l0,87.78l69.3,-0l-0,-87.78l-13.86,0Zm-50.82,83.16l0,-78.54l9.24,0l0,4.62l4.62,0l0,-4.62l32.34,0l-0,4.62l4.62,0l-0,-4.62l9.24,0l-0,78.54l-60.06,-0Zm9.24,-13.86l0,4.62l41.58,-0l-0,-4.62l-41.58,-0Zm41.58,-9.24l-0,4.62l-41.58,-0l0,-4.62l41.58,-0Zm-20.79,-9.24c10.187,-0 18.48,-8.293 18.48,-18.48c-0,-10.187 -8.293,-18.48 -18.48,-18.48c-10.187,0 -18.48,8.293 -18.48,18.48c0,10.187 8.293,18.48 18.48,18.48Zm0,-32.34c7.646,0 13.86,6.214 13.86,13.86c-0,7.646 -6.214,13.86 -13.86,13.86c-7.646,-0 -13.86,-6.214 -13.86,-13.86c0,-7.646 6.214,-13.86 13.86,-13.86Zm-2.31,11.55l0,-6.93l4.62,0l-0,11.55l-11.55,0l0,-4.62l6.93,0Z",
    style: {
      fill: "#fff"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEvents);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/events.5b585f3af0146ca5bea551c574247eb0.svg";